export default {
  setAllNews(state: any, data: any[]) {
    state.allNews = data
  },
  setNewsList(state: any, data: any[]) {
    state.newsList = data
  },
  setPagination(state: any, pagination: {current?: number; pageSize?: number; total?: number}) {
    state.pagination = {...state.pagination, ...pagination}
  },
  setLoading(state: any, loading: boolean) {
    state.loading = loading
  },
  addNews(state: any, news: any) {
    state.allNews.unshift(news)
  },
  updateNewsItem(state: any, updatedNews: any) {
    const index = state.allNews.findIndex((item: any) => item.id === updatedNews.id)
    if (index !== -1) {
      state.allNews.splice(index, 1, updatedNews)
    }
  },
  removeNews(state: any, id: number | string) {
    state.allNews = state.allNews.filter((item: any) => item.id !== id)
  },
  // Public news mutations
  setAllPublicNews(state: any, data: any[]) {
    state.allPublicNews = data
  },
  setPublicNews(state: any, data: any[]) {
    state.publicNews = data
  },
  setPublicNewsPagination(state: any, pagination: {current?: number; pageSize?: number; total?: number}) {
    state.publicNewsPagination = {...state.publicNewsPagination, ...pagination}
  },
  setPublicNewsLoading(state: any, loading: boolean) {
    state.publicNewsLoading = loading
  },
  updatePublicNewsReadStatus(state: any, newsId: number | string) {
    const news = state.publicNews.find((item: any) => item.id === newsId)
    if (news) {
      news.is_read = true
    }
  },
}

